/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useIntl } from 'gatsby-plugin-react-intl';

import RichText, { fragment } from '../../../Core/RichText';
import Link from '../../../Core/Link';
import IndividualBlade from '../../IndividualBlades';
import Carousel from '../../../Core/Carousel';

import FeatureCardCarousel from './FeatureCardCarousel';
import {
  Heading,
  ContentWrapper,
  Footer,
  HeaderWrapper,
  Subheading,
  NavigationWrapper,
  NavigationButton,
  StyledContainer,
} from './styles';

const FeatureCarousel = ({ data }) => {
  if (!data) return null;

  const {
    anchorName,
    backgroundColor,
    contentAlignment,
    elements,
    sectionContainerHeading,
    sectionContainerHeadingColor,
    sectionSubheading,
    ctas,
  } = data;

  const intl = useIntl();

  const breakpoints = {
    320: {
      slidesPerView: '1',
      spaceBetween: 24,
    },
    768: {
      slidesPerView: '2',
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  };

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading
          contentAlignment={contentAlignment}
          headingColor={sectionContainerHeadingColor}
        >
          {children}
        </Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading
          contentAlignment={contentAlignment}
          headingColor={sectionContainerHeadingColor}
        >
          {children}
        </Heading>
      ),
    },
  };

  const subheader = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Subheading>{children}</Subheading>,
    },
  };

  return (
    <StyledContainer
      backgroundColor={backgroundColor}
      // as="section"
      id={anchorName}
    >
      <HeaderWrapper>
        {sectionContainerHeading && (
          <RichText document={sectionContainerHeading} options={header} />
        )}
        {sectionSubheading && (
          <RichText document={sectionSubheading} options={subheader} />
        )}
      </HeaderWrapper>
      <ContentWrapper className={contentAlignment}>
        <Carousel
          breakpoints={breakpoints}
          navigation={{
            nextEl: '.carousel-button-next',
            prevEl: '.carousel-button-prev',
          }}
          modules={[Navigation]}
          loop
        >
          {elements.map(card => {
            return (
              <SwiperSlide key={card.id}>
                <FeatureCardCarousel
                  data={card}
                  className="carousel-cards"
                  forwardedAs="div"
                />
              </SwiperSlide>
            );
          })}
        </Carousel>
        <NavigationWrapper>
          <NavigationButton className="carousel-button-prev">
            {intl.formatMessage({ id: 'prev' })}
          </NavigationButton>
          <NavigationButton className="carousel-button-next">
            {intl.formatMessage({ id: 'next' })}
          </NavigationButton>
        </NavigationWrapper>

        {ctas && (
          <Footer>
            {ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return cta.internal.type === 'ContentfulBlade' ? (
                <IndividualBlade key={cta.id} data={cta} />
              ) : (
                <Link key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Link>
              );
            })}
          </Footer>
        )}
      </ContentWrapper>
    </StyledContainer>
  );
};

FeatureCarousel.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FeatureCarousel;
